import type { O } from 'ts-toolbelt';

import type { Amount as CompleteAmount, CurrencyId } from '@e-socna/data-layer';

import { environment } from '../environment';
import type { MappedReferencesContext } from '../contexts/ReferencesContext';

import { locales } from './locales.util';

type Amount = O.Pick<CompleteAmount, 'value' | 'currencyId'>;

export function formatAmount(
  amount: Amount,
  currenciesIdMap: MappedReferencesContext['currenciesIdMap'],
): string {
  const currencyCode = currenciesIdMap[amount.currencyId as CurrencyId]?.code;

  if (!currencyCode) {
    return new Intl.NumberFormat(locales['fr-FR']).format(amount.value);
  }

  return new Intl.NumberFormat(locales['fr-FR'], {
    style: 'currency',
    currency: currencyCode,
    maximumFractionDigits: environment.amountMaximumFractionDigits,
  }).format(amount.value);
}
